export default class ApiService {

	static get $inject(){
		return [
			'$q', '$http', '$cookies',
			'ApiService'
		];
	}

	constructor($q, $http, $cookies,
	            ApiService){

		this.api = ApiService.api;
		this.errors = ApiService.errors;
		this.successes = ApiService.successes;

		this.$q = $q;
		this.$http = $http;
		this.$cookies = $cookies;

	}

	//a.res(href="https://en.wikipedia.org/wiki/Snake_case", target="_blank") Snake Case.

	get service(){
		return {

			connect: {
				humanName: 'Connect to Control Panel',
				name: 'connect',
				request: {
					contentType: 'Content-Type: application/json;charset=UTF-8',
					type: 'PUT',
					route: '/personal/access/connect',
					data: [
						{ name: 'mac', type: 'String', description: 'Panel MAC address' },
						{ name: 'remoteAccessPassword', type: 'Integer', description: 'Panel remote access password (1-8 digits)' },
						{ name: 'userCode', type: 'Integer', description: 'Panel user code (1-8 digits)' }
					],
					example: angular.toJson({ mac: '0013A1022C7B', remoteAccessPassword: '12345678', userCode: '1234' })
					//example: angular.toJson({ mac: '0013A102184B', remoteAccessPassword: '54541741', userCode: '1234' })
					//example: angular.toJson({ mac: '0013A1022273', remoteAccessPassword: '0001', userCode: '15' })
				},
				response: {
					success: { data: [
						this.successes.status,
						this.successes.state,
						this.successes.message
					] },
					error: { data: [
						this.errors.status,
						this.errors.state,
						this.errors.message
					] }
				},
				submit: (data)=>
					this.$http({
						url: this.api + '/personal/access/connect',
						method: 'PUT',
						data: data,
						headers: { Authorization: 'Bearer ' + this.$cookies.get('token') }
					})
			},

			disconnect: {
				name: 'disconnect',
				request: {
					//contentType: 'Content-Type: application/json;charset=UTF-8',
					type: 'PUT',
					route: '/personal/access/disconnect',
					data: []
				},
				response: {
					success: { data: [
						this.successes.status,
						this.successes.state,
						this.successes.message
					] },
					error: { data: [
						this.errors.status,
						this.errors.state,
						this.errors.message
					] }
				},
				submit: (data)=>
					this.$http({
						url: this.api + '/personal/access/disconnect',
						method: 'PUT',
						data: data,
						headers: { Authorization: 'Bearer ' + this.$cookies.get('token') }
					})
			},

			disconnectMac: {
				name: 'disconnectMac',
				humanName: 'Disconnect control panel by mac',
				description: 'IMPORTANT: For test purpose only. Disconnects Panel with MAC and removes Panel Session in any way without relation to Users connected to it.',
				request: {
					//contentType: 'Content-Type: application/json;charset=UTF-8',
					type: 'PUT',
					route: '/personal/access/disconnect/{mac}',
					params: [
						{ name: 'mac', type: 'String', description: 'Panel MAC address' }
					],
					param: ['0013A102184B']
				},
				response: {
					success: { data: [
						this.successes.status,
						this.successes.state,
						this.successes.message
					] },
					error: { data: [
						this.errors.status,
						this.errors.state,
						this.errors.message
					] }
				},
				submit: (data, param)=>
					this.$http({
						url: this.api + '/personal/access/disconnect/' + param,
						method: 'PUT',
						data: data,
						headers: { Authorization: 'Bearer ' + this.$cookies.get('token') }
					})
			},

			addToAccount: {
				humanName: 'Add Control Panel to account',
				name: 'addToAccount',
				description:'Add CP to account as master with Remote Access Password check',
				request: {
					contentType: 'Content-Type: application/json;charset=UTF-8',
					type: 'POST',
					route: '/personal/access/panel/add',
					data: [
						{ name: 'mac', type: 'String', description: 'Panel MAC address' },
						{ name: 'remoteAccessPassword', type: 'Integer', description: 'Panel remote access password (1-8 digits)' },
						{ name: 'userCode', type: 'Integer', description: 'Panel user code (1-8 digits)' },
						{ name: 'name', type: 'String', description: 'Panel name (optional)' },
						{ name: 'notificationFilter', type: 'Integer', description: 'Notification bitmask filter: num between 0-255 (optional, 255 is default)' }
					],
					example: angular.toJson({ mac: '0013A102184B', remoteAccessPassword: '54541741', userCode: '1234', notificationFilter: 255, name: 'New Panel' })
					//example: angular.toJson({ mac: '0013A102184B', remoteAccessPassword: '12345678', userCode: '1234' })
					//example: angular.toJson({ mac: '0013A1022273', remoteAccessPassword: '0001', userCode: '15' })
				},
				response: {
					success: { data: [
						{ name: 'panelId', type: 'Integer', description: 'Panel Id' },
						{ name: 'userId', type: 'Integer', description: 'User Id' },
						this.successes.status,
						this.successes.state,
						this.successes.message
					] },
					error: { data: [
						this.errors.status,
						this.errors.state,
						this.errors.message
					] }
				},
				submit: (data)=>
					this.$http({
						url: this.api + '/personal/access/panel/add',
						method: 'POST',
						data: data,
						headers: { Authorization: 'Bearer ' + this.$cookies.get('token') }
					})
			}


		}
	}
}



/** WEBPACK FOOTER **
 ** ./src/main/apiTest/services/api.service.personal.access.connect.js
 **/